import classnames from 'classnames/bind';

import { Camera } from 'types/camera';

import { Separator } from 'components/Separator/Separator';

import { CameraDetailNetworkSettings } from './NetworkSettings';
import { CapabilitySettings } from './CapabilitySettings';
import { CredentialSettings } from './CredentialSettings';
import { GatewaySettings } from './GatewaySettings';
import { UniversalBridgeSettings } from './UniversalBridgeSettings';
import styles from './CameraDetailSettings.module.scss';

const c = classnames.bind(styles);

type CameraDetailSettingsProps = {
  camera: Camera;
  streamIds: string[];
};

export function CameraDetailSettings({
  camera,
  streamIds,
}: CameraDetailSettingsProps) {
  const isUsb = camera.conn_type === 'local';
  const isRemote = camera.conn_type === 'remote';
  const isVirtual = camera.conn_type === 'virtual';

  return (
    <div className={c('settings')}>
      {isRemote && (
        <>
          <CredentialSettings camera={camera} />
          <Separator />
          <GatewaySettings camera={camera} />
          <Separator />
          <CameraDetailNetworkSettings camera={camera} />
          <Separator />
        </>
      )}
      {isVirtual && (
        <UniversalBridgeSettings camera={camera} allowedStreamIds={streamIds} />
      )}
      {isUsb && Boolean(camera.capabilities) && (
        <>
          <Separator />
          <CapabilitySettings camera={camera} />
        </>
      )}
    </div>
  );
}
